// Utilities to update the organization picker menu URL templates

/**
 * Update the URLs in the organization picker
 *
 * @param {String} urlTemplate A URL template with an __ORG_ID__ to be substituted
 */
export function updateTopBarUrlTemplate(urlTemplate) {
  const orgPicker = document.querySelector('#org-picker');

  orgPicker.querySelectorAll(':scope a[data-organization-id]').forEach((elem) => {
    elem.href = urlTemplate.replace('__ORG_ID__', elem.getAttribute('data-organization-id'));
  });
}
